import React, { useState } from 'react';
import cn from 'classnames';
import compact from 'lodash/compact';
import { RichTextViewer as QuillRichTextViewer, TextButton, Typography } from 'seagull';
import { Collapse } from '@material-ui/core';
import { RichTextViewer } from "../../../RichTextViewer";
import { useOverlayContext, useIoContext, useStoreActions } from "../../../contexts";
import { ResponsiveModal } from "../../components/ResponsiveModal";
import { useResponsive } from "../../contexts";
import { approvalMethodNoticePeriodModel } from "../../../models";
import { legalTermsModel, relationshipModel } from "../../../models";
import { requestAccountantAccessModel } from "../../../models/request-accountant-access";
import styles from "./AgreementTerms.module.scss";
const TitleTypography = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(Typography, {
    weight: "bold",
    as: "span",
    className: styles.titleTypography
  }, children);
};
export function AgreementTerms(props) {
  const {
    relationship
  } = props;
  const overlayContext = useOverlayContext();
  const {
    api
  } = useStoreActions();
  const {
    isMobile,
    isDesktop
  } = useResponsive();
  const [tocVisible, setTocVisible] = useState(false);
  const {
    openNewTab
  } = useIoContext();
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("section", {
    className: styles.section
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.sectionTitle, {
      [styles.mobile]: isMobile
    })
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    weight: "normal"
  }, "Agreement Terms")), /*#__PURE__*/React.createElement("ul", null, compact([/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TitleTypography, null, "Effective date of agreement: "), relationshipModel.formatEffectiveDate(relationship)), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TitleTypography, null, "Payment terms: "), relationshipModel.paymentTermsText(relationship)), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TitleTypography, null, "Amendments: "), approvalMethodNoticePeriodModel.amendmentsDescription(relationship.amendmentsApprovalMethod)), approvalMethodNoticePeriodModel.isAutoApproval(relationship.invoicesApprovalMethod) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TitleTypography, null, "Out of scope charges: "), approvalMethodNoticePeriodModel.invoicesDescription(relationship.invoicesApprovalMethod)), requestAccountantAccessModel.wasRequested(relationship.requestAccountantAccess) && /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "accountant-access-information"
  }, /*#__PURE__*/React.createElement(TitleTypography, null, "Accountant Access: "), "will allow the ".concat(relationship.vendor.name, " team to view your account information on Anchor, including invoices, agreements, and payments, as well as manage your payment methods. ")), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "additional-terms-of-service"
  }, /*#__PURE__*/React.createElement(TitleTypography, null, "Additional terms of service: "), /*#__PURE__*/React.createElement(TextButton, {
    "data-testid": "additional-terms-of-service-btn",
    onClick: legalTermsModel.isPDF(relationship.legalTerms) ? async () => {
      const pdfViewUrl = await api.business.getLegalTermsDownloadURL(relationship.legalTerms.pdfUniqueName, relationship.vendor.id);
      if (pdfViewUrl) {
        openNewTab(pdfViewUrl);
      }
    } : isMobile ? () => {
      overlayContext.showModal({
        content: _ref2 => {
          let {
            dismissModal
          } = _ref2;
          return /*#__PURE__*/React.createElement(ResponsiveModal, {
            backTitle: "Back to agreement",
            title: "Terms and conditions",
            isDesktop: isDesktop,
            onClose: dismissModal
          }, /*#__PURE__*/React.createElement(RichTextViewer, {
            value: relationship.legalTerms.richTextContent
          }));
        }
      });
    } : () => {
      setTocVisible(!tocVisible);
    }
  }, "Read more")), isDesktop && /*#__PURE__*/React.createElement(Collapse, {
    in: tocVisible
  }, legalTermsModel.isRichText(relationship.legalTerms) ? /*#__PURE__*/React.createElement(RichTextViewer, {
    value: relationship.legalTerms.richTextContent
  }) : /*#__PURE__*/React.createElement(Typography, {
    skin: "secondary"
  }, relationship.coverLetter))), relationship.extraClause && /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "additional-notes",
    className: styles.noteContainer
  }, /*#__PURE__*/React.createElement(TitleTypography, null, "Agreement notes: "), /*#__PURE__*/React.createElement(QuillRichTextViewer, {
    className: styles.note,
    "data-testid": "extra-clause-rich-text-viewer",
    value: relationship.extraClause
  }))]).map((text, idx) => /*#__PURE__*/React.createElement("li", {
    key: idx,
    className: styles.listItem
  }, /*#__PURE__*/React.createElement(Typography, null, text))))));
}